"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var ConfigSubsection_1 = tslib_1.__importDefault(require("../configurationControls/ConfigSubsection"));
var InputControl_1 = tslib_1.__importDefault(require("../configurationControls/InputControl"));
var controlsHelper_1 = require("../../utils/controlsHelper");
var defaultMinMaxControlState = {
    minScale: {
        hasWarning: false,
        warningMessage: "",
        incorrectValue: "",
    },
    maxScale: {
        hasWarning: false,
        warningMessage: "",
        incorrectValue: "",
    },
};
var MinMaxControl = /** @class */ (function (_super) {
    tslib_1.__extends(MinMaxControl, _super);
    function MinMaxControl(props) {
        var _this = _super.call(this, props) || this;
        _this.minInputValidateAndPushDataCallback = function (data) {
            controlsHelper_1.minInputValidateAndPushData(data, _this.state, _this.props, _this.setState.bind(_this), defaultMinMaxControlState);
        };
        _this.maxInputValidateAndPushDataCallback = function (data) {
            controlsHelper_1.maxInputValidateAndPushData(data, _this.state, _this.props, _this.setState.bind(_this), defaultMinMaxControlState);
        };
        _this.state = defaultMinMaxControlState;
        return _this;
    }
    MinMaxControl.getDerivedStateFromProps = function (props) {
        var _a;
        if ((_a = props.propertiesMeta) === null || _a === void 0 ? void 0 : _a.undoApplied) {
            return defaultMinMaxControlState;
        }
        return null;
    };
    MinMaxControl.prototype.render = function () {
        return this.renderMinMaxSection();
    };
    MinMaxControl.prototype.renderMinMaxSection = function () {
        var _a, _b, _c, _d, _e, _f;
        var _g = this.props, properties = _g.properties, basePath = _g.basePath, isDisabled = _g.isDisabled;
        var basePathPropertiesControls = (_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a[basePath];
        var axisScaleMin = (_b = basePathPropertiesControls === null || basePathPropertiesControls === void 0 ? void 0 : basePathPropertiesControls.min) !== null && _b !== void 0 ? _b : "";
        var axisScaleMax = (_c = basePathPropertiesControls === null || basePathPropertiesControls === void 0 ? void 0 : basePathPropertiesControls.max) !== null && _c !== void 0 ? _c : "";
        var axisVisible = (_d = basePathPropertiesControls === null || basePathPropertiesControls === void 0 ? void 0 : basePathPropertiesControls.visible) !== null && _d !== void 0 ? _d : true;
        return (react_1.default.createElement(ConfigSubsection_1.default, { title: "properties.axis.scale" },
            react_1.default.createElement(InputControl_1.default, { valuePath: basePath + ".min", labelText: "properties.axis.min", placeholder: "properties.auto_placeholder", type: "number", hasWarning: this.minScaleHasWarning(), value: this.minScaleHasIncorrectValue() ? (_e = this.state.minScale) === null || _e === void 0 ? void 0 : _e.incorrectValue : axisScaleMin, disabled: isDisabled || !axisVisible, properties: properties, pushData: this.minInputValidateAndPushDataCallback }),
            this.renderMinErrorMessage(),
            react_1.default.createElement(InputControl_1.default, { valuePath: basePath + ".max", labelText: "properties.axis.max", placeholder: "properties.auto_placeholder", type: "number", hasWarning: this.maxScaleHasWarning(), value: this.maxScaleHasIncorrectValue() ? (_f = this.state.maxScale) === null || _f === void 0 ? void 0 : _f.incorrectValue : axisScaleMax, disabled: isDisabled || !axisVisible, properties: properties, pushData: this.maxInputValidateAndPushDataCallback }),
            this.renderMaxErrorMessage()));
    };
    MinMaxControl.prototype.minScaleHasIncorrectValue = function () {
        var _a, _b;
        return ((_b = (_a = this.state.minScale) === null || _a === void 0 ? void 0 : _a.incorrectValue) !== null && _b !== void 0 ? _b : "") !== "";
    };
    MinMaxControl.prototype.maxScaleHasIncorrectValue = function () {
        var _a, _b;
        return ((_b = (_a = this.state.maxScale) === null || _a === void 0 ? void 0 : _a.incorrectValue) !== null && _b !== void 0 ? _b : "") !== "";
    };
    MinMaxControl.prototype.minScaleHasWarning = function () {
        var _a, _b;
        return (_b = (_a = this.state.minScale) === null || _a === void 0 ? void 0 : _a.hasWarning) !== null && _b !== void 0 ? _b : false;
    };
    MinMaxControl.prototype.maxScaleHasWarning = function () {
        var _a, _b;
        return (_b = (_a = this.state.maxScale) === null || _a === void 0 ? void 0 : _a.hasWarning) !== null && _b !== void 0 ? _b : false;
    };
    MinMaxControl.prototype.renderMinErrorMessage = function () {
        var _a, _b;
        var minScaleWarningMessage = (_b = (_a = this.state.minScale) === null || _a === void 0 ? void 0 : _a.warningMessage) !== null && _b !== void 0 ? _b : "";
        if (!this.minScaleHasWarning() || minScaleWarningMessage === "") {
            return false;
        }
        return (react_1.default.createElement(sdk_ui_kit_1.Message, { type: "warning", className: "adi-input-warning" }, minScaleWarningMessage));
    };
    MinMaxControl.prototype.renderMaxErrorMessage = function () {
        var _a, _b;
        var maxScaleWarningMessage = (_b = (_a = this.state.maxScale) === null || _a === void 0 ? void 0 : _a.warningMessage) !== null && _b !== void 0 ? _b : "";
        if (!this.maxScaleHasWarning() || maxScaleWarningMessage === "") {
            return false;
        }
        return (react_1.default.createElement(sdk_ui_kit_1.Message, { type: "warning", className: "adi-input-warning" }, maxScaleWarningMessage));
    };
    return MinMaxControl;
}(react_1.default.Component));
exports.default = react_intl_1.injectIntl(MinMaxControl);
//# sourceMappingURL=MinMaxControl.js.map